import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

export class Country {
  name: string;
  code: number;
  alpha2: string;
  alpha3: string;
  currency: string;
  flag: string;

  constructor(base?: Partial<Country>) {
    if (base) {
      Object.assign(this, base);
    }
  }
}

@Injectable({ providedIn: 'root' })
export class SgIsoStore {
  ready: boolean;

  get onReady(): Promise<boolean> {
    this.init();
    return this.onReady$.closed ? Promise.resolve(true) : this.onReady$.toPromise();
  }

  get allCurrencies(): Array<[string, Country[]]> {
    return Array.from(this.currency.entries());
  }

  private onReady$: Subject<boolean>;
  private currency = new Map<string, Country[]>();
  private alpha2 = new Map<string, Country>();
  private alpha3 = new Map<string, Country>();

  init(beforeEmitReady?: () => void): void {
    if (this.onReady$) {
      return;
    }
    this.onReady$ = new Subject<boolean>();
    require.ensure([], () => {
      const countries = require('./data/country.json');
      for (const c of countries) {
        let curr = this.currency.get(c.currency);
        if (!curr) {
          this.currency.set(c.currency, (curr = []));
        }
        curr.push(c);
        this.alpha2.set(c.alpha2, c);
        this.alpha3.set(c.alpha3, c);
      }
      if (beforeEmitReady) {
        beforeEmitReady();
      }
      this.ready = true;
      this.onReady$.next(true);
      this.onReady$.complete();
    });
  }

  has(alpha: string): boolean {
    const len = alpha ? alpha.length : 0;
    switch (len) {
      case 2:
        return this.alpha2.has(alpha);
      case 3:
        return this.alpha3.has(alpha);
    }
    return false;
  }

  byCurrencyCode(currencyCode: string): Country[] {
    return this.currency.get(currencyCode) || [];
  }

  query(alpha: string): Country | undefined {
    const len = alpha ? alpha.length : 0;
    switch (len) {
      case 2:
        return this.alpha2.get(alpha);
      case 3:
        return this.alpha3.get(alpha);
    }
  }
}
